import {
  InAppMessage,
  inAppMessageContentKeys,
  isAllowedURIforBraze,
  isInAppMessageActionButtonAction,
  isInAppMessageContentKey,
  isInAppMessageOptionalContentKey,
  isInAppMessageTextStyle,
  isInAppMessageType,
} from '../../../client/braze/types';
import { logger } from '../../../common/logger';

// exported for testing
export const inAppMessageValidator = (message: InAppMessage): boolean => {
  // check that all the keys in InAppMessageContentKeys are in messages.extras
  for (const key of inAppMessageContentKeys) {
    if (!message.extras[key]) {
      logger.error(`In-app message key "${key}" missing.`, message);
      return false;
    }
  }

  // check that all the keys in messages.extras are in InAppMessageContentKeys or OptionalKeys
  for (const key in message.extras) {
    if (
      !isInAppMessageContentKey(key) &&
      !isInAppMessageOptionalContentKey(key)
    ) {
      logger.error(`Unknown In-app message key: ${key}.`, message);
      return false;
    }
  }

  if (!isInAppMessageType(message.extras.type)) {
    logger.error('In-app message type invalid or missing.', message);
    return false;
  }

  if (message.extras.imgUrl) {
    // only braze cdn is allowed
    const regex = /^https:\/\/cdn\.braze\.eu\//;
    const isValidUrl = regex.test(message.extras.imgUrl);

    if (!isValidUrl) {
      logger.error('In-app message imgUrl invalid.', message);
      return false;
    }
  }

  if (
    (message.extras.actionButtonLabel_fi &&
      !message.extras.actionButtonLabel_sv) ||
    (!message.extras.actionButtonLabel_fi &&
      message.extras.actionButtonLabel_sv)
  ) {
    logger.error(
      'In-app message action button label missing a localized label.',
      message
    );
    return false;
  }

  if (
    message.extras.actionButtonAction &&
    !isInAppMessageActionButtonAction(message.extras.actionButtonAction)
  ) {
    logger.error(
      'In-app message action button action invalid or missing.',
      message
    );
    return false;
  }

  if (
    message.extras.actionButtonLabel_fi &&
    !isInAppMessageActionButtonAction(message.extras.actionButtonAction)
  ) {
    logger.error(
      'In-app message has actionButton label but invalid actionButtonAction.',
      message
    );
    return false;
  }

  if (
    message.extras.actionButtonAction === 'redirect' &&
    (!message.extras.redirect_uri ||
      !isAllowedURIforBraze(message.extras.redirect_uri))
  ) {
    logger.error(
      'In-app message action set for redirect but redirect_uri invalid or missing.',
      message
    );
    return false;
  }

  if (
    message.extras.text_style &&
    !isInAppMessageTextStyle(message.extras.text_style)
  ) {
    logger.error('In-app message text style invalid.', message);
    return false;
  }

  return true;
};
